export default {
  primary: "#00d8ff",
  secondary: "#222222",
}
